export const valueOrUndefined = <T = any>(bool: boolean, v: T) => (bool ? v : undefined)
